import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CompanyDetails } from '@app-utils';

/**
 *
 */
@Injectable({
  providedIn: 'root',
})
export class AuthFlowService {
  private readonly _tempToken$ = new BehaviorSubject<string>('');
  private readonly _details$ = new BehaviorSubject<CompanyDetails | null>(null);

  get companyDetail$(): Observable<CompanyDetails | null> {
    return this._details$.asObservable();
  }

  getCompanyDetail(): CompanyDetails | null {
    return this._details$.value;
  }

  setCompanyDetail(data: CompanyDetails | null): void {
    this._details$.next(data);
  }

  get tempToken$(): Observable<string> {
    return this._tempToken$.asObservable();
  }

  getTempToken(): string {
    return this._tempToken$.value;
  }

  setTempToken$(data: string): void {
    this._tempToken$.next(data);
  }
}
